"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
import { FileText } from "lucide-react";
interface CustomMeshQuoteCtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, CustomMeshQuoteCtaCopy> = {
  en: {
    eyebrow: "Engineering & Technical Resources",
    heading: "Engineered Stainless Steel Mesh Built to Your Exact Specifications",
    lead: "Whether you need prototype filter screen discs, custom sintered laminates, or production-volume rolls, MutualFilter provides technical engineering, material verification, and industrial B2B supply.",
    secondaryLabel: "Technical Resources"
  },
  zh: {
    eyebrow: "工程与技术资源",
    heading: "按严格技术规范精密制造的不锈钢过滤丝网",
    lead: "无论是样品试制滤片、定制烧结网复合层板，还是大批量标准卷网，MutualFilter 均可提供工程技术支持、材质检验与可靠的工业级 B2B 供货。",
    secondaryLabel: "技术资源中心"
  },
  es: {
    eyebrow: "Ingeniería y recursos técnicos",
    heading: "Malla de acero inoxidable fabricada según sus especificaciones exactas",
    lead: "Ya sean discos de filtro para prototipos, laminados sinterizados a medida o rollos de producción en serie, MutualFilter ofrece ingeniería técnica, verificación de materiales y suministro B2B fiable.",
    secondaryLabel: "Recursos técnicos"
  },
  de: {
    eyebrow: "Ingenieurwesen & technische Ressourcen",
    heading: "Präzises Edelstahl-Drahtgewebe nach Ihren exakten Spezifikationen",
    lead: "Ob Prototypen-Filterscheiben, kundenspezifische Sinterlaminate oder Serienrollen – MutualFilter bietet technische Auslegung, Materialprüfung und zuverlässige B2B-Belieferung.",
    secondaryLabel: "Technische Ressourcen"
  },
  fr: {
    eyebrow: "Ingénierie et ressources techniques",
    heading: "Toile métallique inox conçue selon vos spécifications exactes",
    lead: "Qu'il s'agisse de disques filtrants prototypes, de stratifiés frittés sur mesure ou de rouleaux de production, MutualFilter assure l'ingénierie technique, le contrôle matière et la fourniture industrielle.",
    secondaryLabel: "Ressources techniques"
  },
  pt: {
    eyebrow: "Engenharia e recursos técnicos",
    heading: "Malha de aço inoxidável desenvolvida conforme suas especificações",
    lead: "Sejam discos de filtro para protótipos, laminados sinterizados sob medida ou rolos de produção, a MutualFilter fornece engenharia técnica, verificação de materiais e fornecimento B2B confiável.",
    secondaryLabel: "Recursos técnicos"
  }
};
export default function CustomMeshQuoteCTA() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="custommeshquotecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/TechnicalResourcesPage",
    icon: FileText
  }} />;
}